// Models
import { TMuscleGroupFilter } from 'models'

// React
import { FC } from 'react'

// Misc
import { buttonClickTracking } from 'utils/tracking'

// Components
import * as Styled from './styled'
import { Aligner, IconButton, InputSearch } from 'heeds-ds'

interface Props {
  filters?: TMuscleGroupFilter[]
  hasSelectedFilters?: boolean
  margin?: string
  onClickFilter: () => void
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  padding?: string
  removeFilter: (label: string) => void
  searchQuery?: string
}

const ExerciseSearchBar: FC<Props> = ({
  filters,
  margin,
  onClickFilter,
  onSearchChange,
  padding,
  removeFilter,
  searchQuery = '',
}) => {
  return (
    <Aligner flex="column" gap="1.6rem" margin={margin} padding={padding}>
      <Aligner
        align="center"
        data-testid="exercise-input-container"
        gap="1.6rem"
      >
        <InputSearch
          margin="0"
          onChange={onSearchChange}
          placeholder="Pesquisar exercícios"
          scale="small"
          value={searchQuery}
        />

        <IconButton
          iconName="filter"
          margin="0.25rem 0"
          onClick={onClickFilter}
          size="xsmall"
          track={buttonClickTracking}
          trackName="open_muscle_group_filter_modal"
          variation="main"
        />
      </Aligner>

      <Styled.FiltersContainer data-testid="exercise-filter-container">
        {filters?.map((filter, index) => {
          if (filter.active) {
            return (
              <Styled.TagButton
                key={index}
                onClick={() => removeFilter(filter.name)}
              >
                {filter.label}

                <Styled.CloseIcon />
              </Styled.TagButton>
            )
          }
        })}
      </Styled.FiltersContainer>
    </Aligner>
  )
}

export default ExerciseSearchBar
